import { render } from "./DoctorGeneralInformation.vue?vue&type=template&id=09309929&scoped=true&ts=true"
import script from "./DoctorGeneralInformation.vue?vue&type=script&lang=ts"
export * from "./DoctorGeneralInformation.vue?vue&type=script&lang=ts"

import "./DoctorGeneralInformation.vue?vue&type=style&index=0&id=09309929&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09309929"]])

export default __exports__